module.exports = __webpack_public_path__ + "static/media/sg14cr823.06a46243.png";